module.exports = __webpack_public_path__ + "img/cnd_Fixing.2af646f3.svg";